import { useState, useEffect } from "react";

/**
 * Custom hook to detect if the viewport is mobile (< 768px).
 * @returns {boolean} isMobile
 */
const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 767px)");

    // Initial check
    setIsMobile(mediaQuery.matches);

    // Listener for changes
    const handler = (e) => setIsMobile(e.matches);
    mediaQuery.addEventListener("change", handler);

    return () => mediaQuery.removeEventListener("change", handler);
  }, []);

  return isMobile;
};

export default useIsMobile;
